export default "__VITE_ASSET__BeUwod4d__"